import { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "@phosphor-icons/react";

export default function ConfirmCodeDialog({
    open,
    title,
    description,
    onConfirm,
    onClose,
}) {
    const [code, setCode] = useState("");

    useEffect(() => {
        if (open) setCode("");
    }, [open]);

    const submit = (e) => {
        e?.preventDefault();
        if (!code) return;
        onConfirm(code);
    };

    return (
        <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
            <DialogContent
                className="rounded-none max-w-md border-2 border-[#FF3B30]"
                data-testid="confirm-code-dialog"
            >
                <DialogHeader>
                    <DialogTitle className="font-heading text-2xl font-black tracking-tighter flex items-center gap-2">
                        <Lock size={20} weight="fill" className="text-[#FF3B30]" />
                        {title || "ΕΠΙΒΕΒΑΙΩΣΗ"}
                    </DialogTitle>
                    {description && (
                        <DialogDescription className="text-sm text-[#5C5F66]">
                            {description}
                        </DialogDescription>
                    )}
                </DialogHeader>
                <form onSubmit={submit} className="space-y-3 mt-2">
                    <Label className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#5C5F66]">
                        ΚΩΔΙΚΟΣ ΕΠΙΒΕΒΑΙΩΣΗΣ
                    </Label>
                    <Input
                        type="password"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        autoFocus
                        data-testid="confirm-code-input"
                        className="rounded-none h-12 border-2 border-[#0A0A0A] text-base font-mono"
                        placeholder="••••"
                    />
                    <DialogFooter>
                        <Button
                            type="button"
                            onClick={onClose}
                            variant="outline"
                            data-testid="confirm-code-cancel"
                            className="rounded-none h-11 border-2 border-[#0A0A0A] font-bold"
                        >
                            ΑΚΥΡΩΣΗ
                        </Button>
                        <Button
                            type="submit"
                            disabled={!code}
                            data-testid="confirm-code-ok"
                            className="rounded-none h-11 bg-[#FF3B30] hover:bg-[#D72D24] text-white font-black tracking-wider"
                        >
                            ΕΠΙΒΕΒΑΙΩΣΗ
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
}
